import { StencilTestMfe } from '@/features/microfrontends/StencilTestMfe';
import { FeatureToggle, useFeatureToggle } from '@/hooks/useFeatureToggle';

const StencilTest = () => {
    const { featureToggleValue: isStencilTestFeatureEnabled } = useFeatureToggle(FeatureToggle.ENABLE_STENCIL_TEST);
    if (!isStencilTestFeatureEnabled) {
        return null;
    }
    return <StencilTestMfe />;
};

export default StencilTest;
